import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {BacnetDataPoint} from "../../../../domain/device.interface";
import {BacnetDeviceService} from "../../../../services/bacnet-device.service";
import {BacnetDataPointAPI} from "../../../../domain/bacnet-datapoint";
import {NotificationService} from "../../../../services/notification.service";
import {BacnetDeviceNameDescription} from "../../../../domain/bacnet-device";
import {EventBrokerService} from "../../service/event-broker.service";

const LOAD_GATEWAY_DETAILS_EVENT = "LOAD_GATEWAY_DETAILS_EVENT";

@Component({
  selector: 'eis-gateway-bacnet-preview-undeployed-datapoints',
  templateUrl: './bacnet-preview-undeployed-datapoints.component.html',
  styleUrls: ['./bacnet-preview-undeployed-datapoints.component.scss']
})
export class BacnetPreviewUndeployedDatapointsComponent implements OnInit {


  addedDataPoints: BacnetDataPoint[] = [];
  deletedDataPoints: BacnetDataPoint[] = [];
  updatedDataPoints: BacnetDataPoint[] = [];
  deleteDataPointsInIoT = true;

  deletedDevices: BacnetDeviceNameDescription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { gatewaySerial: string, tenant: string },
    public dialogRef: MatDialogRef<BacnetPreviewUndeployedDatapointsComponent>,
    private bacnetService: BacnetDeviceService,
    private notificationService: NotificationService,
    private eventBrokerService:EventBrokerService,
  ) {
  }

  ngOnInit(): void {
    this.loadData()

  }

  selectedTabChange($event: MatTabChangeEvent) {
    //todo
  }

  closeDialog() {
    this.dialogRef.close()
  }


  private loadData() {
    this.bacnetService.getDatapointsByGatewaySerialAndDeploymentStatus(this.data.gatewaySerial, "PENDING_ADD")
      .subscribe(data => {
        this.addedDataPoints = data.map(it => this.toCoreModel(it))

      })
    this.bacnetService.getDatapointsByGatewaySerialAndDeploymentStatus(this.data.gatewaySerial, "PENDING_UPDATE_POLLING_STATUS")
      .subscribe(data => {
        this.updatedDataPoints = data.map(it => this.toCoreModel(it))

      })
    this.bacnetService.getDatapointsByGatewaySerialAndDeploymentStatus(this.data.gatewaySerial, "PENDING_DELETE")
      .subscribe(data => {
        this.deletedDataPoints = data.map(it => this.toCoreModel(it))

      })
    this.bacnetService.getDevicePendingDeleteStatus(this.data.gatewaySerial, )
      .subscribe(data => {
        this.deletedDevices = data

      })
  }


  applyChanges() {
    this.bacnetService.deployBacnetConfigToGateway(this.data.tenant, this.data.gatewaySerial, this.deleteDataPointsInIoT)
      .subscribe(result => {
        this.isSucces(result);

        if (result.failedRequests >= 1) {
            this.notificationService.failure(`bacnet-preview-changes.apply.fail`)
          }

        }
      )
  }

  private isSucces(result: { successfulRequests: number; failedRequests: number }) {
    if (result.failedRequests == 0) {
      this.dialogRef.close()
      this.eventBrokerService.sendEvent(LOAD_GATEWAY_DETAILS_EVENT)

    }

    if (result.successfulRequests >= 1) {
      this.notificationService.success(`bacnet-preview-changes.apply.success`)
    }
  }

  toCoreModel(it: BacnetDataPointAPI): BacnetDataPoint {
    return {
      deploymentStatus: "",
      id: it.id,
      deviceId: it.deviceName,
      dataType: it.objectName,
      key: it.key,
      value: it.value,
      unit: it.units,
      description: it.description,
      pollingIntervalSeconds: it.pollingIntervalSeconds

    }
  }


}
